import { ref } from 'vue';
import { useLoading } from '@/composables/useLoading';
import { useChubbQuote } from './quoteGeneration/chubbQuote';
import { runFetchQuotes } from './quoteGeneration/fetchQuotes';
import { runGenerateQuote } from './quoteGeneration/generateQuote';
import { toFetchQuotesParams } from './quoteGeneration/types';
import type { FetchQuotesOptions, QuoteGenerationContext } from './quoteGeneration/types';
import type { CotizaTodasResponse, QuoteData } from '@/types/quote.types';

export const useQuoteGeneration = () => {
  const { showLoading, hideLoading } = useLoading();
  const chubb = useChubbQuote();
  const state = {
    quotesResponse: ref<CotizaTodasResponse | null>(null),
    anaQuotes: ref<CotizaTodasResponse | null>(null),
    isLoading: ref(false),
    isFetchingQuotes: ref(false), // Solo para cotizaTodas, no para Insert/Update
    error: ref<string | null>(null),
  };
  const ctx: QuoteGenerationContext = { state, loading: { showLoading, hideLoading } };

  const generateQuote = (
    quoteData: QuoteData,
    isUpdate = false,
    showLoadingScreen = true,
  ): Promise<{ Id_Cotizacion?: number; Id_Cotizacion_Autos_Detalle?: number } | null> =>
    runGenerateQuote(ctx, quoteData, isUpdate, showLoadingScreen);

  const fetchQuotes = (options: FetchQuotesOptions): Promise<void> =>
    runFetchQuotes(ctx, toFetchQuotesParams(options));

  return { ...state, ...chubb, generateQuote, fetchQuotes };
};
